const TIMEOUT_SESSION_DURATION_IN_MINUTES = 50;
const TIMEOUT_SESSION_WARNING_IN_MINUTES = 45;
const LAST_SEEN_DAYS = 30;
const HAMBURGER_EXTENDED_WIDTH = 255;
const HAMBURGER_MINIFIED_WIDTH = 136;
const OUTLETS_WIDTH = 800;
const OUTLETS_PADDING = 40;
const OUTLETS_PADDING_MOBILE = 12;
const OUTLETS_PADDING_TOP = 30;
const OUTLETS_PADDING_TOP_MOBILE = 12;
const IS_SCRAMBLING_MODE = !!localStorage.getItem('scramble') && localStorage.getItem('scramble') === 'true';

export const Constants = {
  TIMEOUT_SESSION_DURATION_IN_MINUTES,
  TIMEOUT_SESSION_WARNING_IN_MINUTES,
  LAST_SEEN_DAYS,
  HAMBURGER_EXTENDED_WIDTH,
  HAMBURGER_MINIFIED_WIDTH,
  OUTLETS_WIDTH,
  OUTLETS_PADDING,
  OUTLETS_PADDING_TOP,
  IS_SCRAMBLING_MODE,
  OUTLETS_PADDING_MOBILE,
  OUTLETS_PADDING_TOP_MOBILE,
};
